import { useQuery } from "react-query";
import api from "../services/api";
import useAuth from "./use-auth";
import useIsAuthenticated from "./use-is-authenticated";

type ReferralCodeResponse = {
  referralCode: string;
};

async function getUserReferralCode() {
  const response = await api.get(`/rs/referral/code`);

  if (response.ok) {
    const json = (await response.json()) as ReferralCodeResponse;
    return json.referralCode;
  } else if (response.status === 404) {
    return null;
  }

  throw new Error("Could not fetch user referral code");
}

export default function useUserReferralCode() {
  const isAuthenticated = useIsAuthenticated();

  return useQuery("user-referral-code", getUserReferralCode, {
    staleTime: 1000 * 60 * 60 * 48, // 48 hours
    enabled: isAuthenticated
  });
}
